import { createAction } from '@reduxjs/toolkit';
import { IMessageModel } from '../../../model/communication/Message';

export const initBotChatSession = createAction('INIT_BOT_CHAT_SESSION');

export const hydrateBotChatFromSaved = createAction<{ communicationId: string; sessionId?: string; messages: IMessageModel[] }, 'HYDRATE_BOT_CHAT_FROM_SAVED'>('HYDRATE_BOT_CHAT_FROM_SAVED');

export const sendBotChatMessage = createAction<{ content: string }, 'SEND_BOT_CHAT_MESSAGE'>('SEND_BOT_CHAT_MESSAGE');

export const addBotChatUserMessage = createAction<{ message: IMessageModel }, 'ADD_BOT_CHAT_USER_MESSAGE'>('ADD_BOT_CHAT_USER_MESSAGE');

export const setBotChatSessionId = createAction<{ sessionId: string }, 'SET_BOT_CHAT_SESSION_ID'>('SET_BOT_CHAT_SESSION_ID');

export const botChatResponseChunk = createAction<{ chunk: string; timestamp: number }, 'BOT_CHAT_RESPONSE_CHUNK'>('BOT_CHAT_RESPONSE_CHUNK');

export const botChatResponseEnd = createAction<{ response: string; sessionId: string }, 'BOT_CHAT_RESPONSE_END'>('BOT_CHAT_RESPONSE_END');

export const setBotChatWorking = createAction<{ working: boolean }, 'SET_BOT_CHAT_WORKING'>('SET_BOT_CHAT_WORKING');

export const saveBotChatRequest = createAction<{ title: string }, 'SAVE_BOT_CHAT_REQUEST'>('SAVE_BOT_CHAT_REQUEST');

export const saveBotChatSuccess = createAction<{ communicationId: string; alias: string }, 'SAVE_BOT_CHAT_SUCCESS'>('SAVE_BOT_CHAT_SUCCESS');

export const saveBotChatFailed = createAction<{ error: string }, 'SAVE_BOT_CHAT_FAILED'>('SAVE_BOT_CHAT_FAILED');

/**
 * Opens a complaint chat about the given bot turn with the configured contact.
 * The saga navigates to the created chat.
 */
export const createComplaintRequest = createAction<{ botSessionId?: string; question: string; answer: string }, 'CREATE_COMPLAINT_REQUEST'>('CREATE_COMPLAINT_REQUEST');

export const createComplaintSuccess = createAction<{ id: string; alias?: string }, 'CREATE_COMPLAINT_SUCCESS'>('CREATE_COMPLAINT_SUCCESS');

export const createComplaintFailed = createAction<{ error?: string }, 'CREATE_COMPLAINT_FAILED'>('CREATE_COMPLAINT_FAILED');

export const discardBotChat = createAction('DISCARD_BOT_CHAT');

export const resetBotChat = createAction('RESET_BOT_CHAT');

export const deleteBotChatRequest = createAction<{ communicationId: string }, 'DELETE_BOT_CHAT_REQUEST'>('DELETE_BOT_CHAT_REQUEST');

export const deleteBotChatSuccess = createAction<{ communicationId: string }, 'DELETE_BOT_CHAT_SUCCESS'>('DELETE_BOT_CHAT_SUCCESS');

export const deleteBotChatFailed = createAction<{ communicationId: string; error: string }, 'DELETE_BOT_CHAT_FAILED'>('DELETE_BOT_CHAT_FAILED');
